import type { JSX } from "preact";
import { classNames } from "@gss/common/classNames";
import { Warning } from "./icons";

interface Params {
    className?: string;
    title?: string;
}

export function IconValidationError({ className, title }: Params): JSX.Element {
    return (
        <Warning
            className={classNames("text-danger", className)}
            title={title}
        />
    );
}

export function IconValidationWarning({
    className,
    title,
}: Params): JSX.Element {
    return (
        <Warning
            className={classNames("text-warning", className)}
            title={title}
        />
    );
}
